import type React from 'react';
import type { CTA } from '../../config/types';
import SearchBarCTAButton from '../SearchBarCTAButton';

interface SearchBarCTAGroupProps {
    ctas: CTA[];
    showCtas: boolean;
    ctaAnimationKey?: number;
    domain: string;
    isCopilotLayout?: boolean;
    isCtaPage?: boolean;
    hadDemoOffer?: boolean;
    inlineCtaOptionEnabled?: boolean;
    visitorEmail?: string | null;
    onBookingFlowStart?: (
        ctaId: string,
        redirectUrl: string,
        bookingMessage: string,
        ctaAction?: 'navigate' | 'popup' | 'in-chat'
    ) => void;
    onMinimize?: () => void;
}

const SearchBarCTAGroup: React.FC<SearchBarCTAGroupProps> = ({
    ctas,
    showCtas,
    ctaAnimationKey,
    domain,
    isCopilotLayout = false,
    isCtaPage,
    hadDemoOffer,
    inlineCtaOptionEnabled,
    visitorEmail,
    onBookingFlowStart,
    onMinimize,
}) => {
    // Copilot keeps one sales CTA, plus any intent-gated CTA (e.g. a help-center link).
    const visibleCtas = isCopilotLayout
        ? [
              ...ctas.filter((cta) => !cta.show_on_intents?.length).slice(0, 1),
              ...ctas.filter((cta) => cta.show_on_intents?.length),
          ]
        : ctas.slice(0, 10);

    return (
        <div
            className="rose-search-bar-ctas-container relative"
            style={{
                maxHeight: showCtas ? '300px' : '0px',
                opacity: showCtas ? 1 : 0,
                overflow: 'hidden',
                transition: 'all 0.3s ease-out',
                transitionDelay: showCtas ? '0.3s' : '0s',
            }}
        >
            <div className="flex flex-wrap gap-[10px] items-start">
                {visibleCtas.map((cta, index) => (
                    <SearchBarCTAButton
                        key={`${cta.placeholder}-${index}-${ctaAnimationKey ?? ''}`}
                        domain={domain}
                        placeholder={cta.placeholder}
                        show={showCtas}
                        variant={index >= 1 ? 'cta-secondary' : 'cta-primary'}
                        showArrow={index === 0}
                        fontWeight={index === 0 ? 'font-bold' : 'font-normal'}
                        isCtaPage={isCtaPage}
                        hadDemoOffer={hadDemoOffer}
                        inlineCtaOptionEnabled={inlineCtaOptionEnabled}
                        visitorEmail={visitorEmail}
                        onBookingFlowStart={onBookingFlowStart}
                        onMinimize={onMinimize}
                    />
                ))}
            </div>
        </div>
    );
};

export default SearchBarCTAGroup;
